/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isProjectSchema(data: any): boolean {
  return data && data.componentsTree;
}
